export const FREE = 'FREE';
export const PORTAL_BASED = 'PORTAL_BASED';
export const SEAT_BASED = 'SEAT_BASED';
export const CONTACT_BASED = 'CONTACT_BASED';